module.exports = __webpack_public_path__ + "img/sass.2ca68cea.png";